import { Component, effect, input, signal } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'app-loading-page',
  standalone: true,
  imports: [TranslocoModule],
  templateUrl: './loading-page.component.html',
  styleUrls: ['./loading-page.component.scss'],
})
export class LoadingPageComponent {
  readonly title     = input('PARTNER CORE');
  readonly isLoading = input(true);

  protected readonly fadeOut = signal(false);

  constructor() {
    effect(() => {
      this.fadeOut.set(!this.isLoading());
    });
  }
}
